<template>
  <div
    class="flex w-full gap-1 bg-gray-50"
    :class="{ 'flex-col': !verticalAlignment }"
  >
    <div class="flex justify-between gap-3">
      <aside :class="`flex items-center justify-between gap-2 ${classes}`">
        <button
          v-for="(tab, index) in tabNames"
          :key="index"
          type="button"
          class="w-full border-emerald-400 px-6 py-3 text-sm font-semibold capitalize text-gray-400 outline-none transition-all duration-100"
          :class="{
            'rounded-t': !verticalAlignment,
            'rounded-l': verticalAlignment,
            'border-b-4 text-slate-900':
              !verticalAlignment
              && activeTab.toLowerCase() === tab.toLowerCase(),
            'border-l-4 text-slate-900':
              verticalAlignment
              && activeTab.toLowerCase() === tab.toLowerCase(),
          }"
          @click="
            activeTab = tab;
            $emit('tabChanged', tab);
          "
        >
          {{ tab }}
        </button>
      </aside>
    </div>
    <main
      class="w-full border-gray-300 bg-white"
      :class="{
        'border-t pt-2.5': !verticalAlignment,
        'border-l pl-2.5': verticalAlignment,
      }"
    >
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  name: 'GeneralTabs',

  props: {
    names: {
      type: Array,
      required: true,
    },
    active: {
      type: String,
      default: null,
    },
    classes: {
      type: String,
      default: '',
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['tabChanged'],

  data() {
    return {
      tabNames: this.names,
      activeTab: this.active ?? this.names[0],
      verticalAlignment: this.vertical,
    }
  },

  watch: {
    names(newNames) {
      this.tabNames = newNames
    },
    active(newActive) {
      this.activeTab = newActive
    },
    vertical(isAlignedVertically) {
      this.verticalAlignment = isAlignedVertically
    },
  },
}
</script>
